import {
  ServiceEventEditFormProps,
  ServiceEventEditFormRawValues,
  ServiceEventEditFormType
} from "./ServiceEventEditForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {isBefore, isStringUndefinedOrBlank} from "@ots-frontend/ots-data";
import {DefaultTFuncReturn} from "i18next";
import {ServiceEventFormDefaultValues} from "./ServiceEventForm";

const getInitialValues = (defaultValues: ServiceEventFormDefaultValues | undefined): ServiceEventEditFormRawValues => {
  return {
    name: defaultValues?.name,
    severityLevel: defaultValues?.severityLevel,
    startDate: defaultValues?.startDate,
    endDate: defaultValues?.endDate,
    closeoutPolicy: defaultValues?.closeoutPolicy?.code,
    note: defaultValues?.note,
  }
}

export type UseServiceEventEditFormProps = Pick<ServiceEventEditFormProps, 'defaultValues'> & {}

export function useServiceEventEditForm(props: UseServiceEventEditFormProps): ServiceEventEditFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      name: (value) => !isStringUndefinedOrBlank(value) ? undefined : t("common.validation.required", "Required"),
      startDate: (value) => value ? undefined : t("common.validation.required", "Required"),
      endDate: (value, values) => {
        let error: string | DefaultTFuncReturn | undefined = undefined

        if (value && values.startDate && isBefore(value, values.startDate)) {
          error = t<string>("common.form.validation.enddatebefore", "The end date can't be before the start date")
        }

        return error
      },
      closeoutPolicy: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
